import { localConfig } from './local'
import { prodConfig } from './prod'
import { stagingConfig } from './staging'

interface Environment {
  production: boolean
  env: string
  SERVER_ADDR: string
  TRACK_SERVER_ADDR: string
  ADMIN_SERVER_ADDR: string
  ANALYTICS_SERVER_ADDR: string
  STRIPE_PUBLISHABLE_KEY: string
  SUB_URI_V2: string
  VERSION: string
  TOOLBAR_COLOR: string
  SHOPIFY_FLOW: string
}

const getRuntimeNodeEnv = () => {
  if (typeof process !== 'undefined' && process.env?.NODE_ENV) {
    return process.env.NODE_ENV
  }

  return 'production'
}

const getEnvConfig = (): Environment => {
  const env = getRuntimeNodeEnv()
  switch (env.toLowerCase()) {
    case 'production':
    case 'prod':
      return prodConfig
    case 'staging':
      return stagingConfig
    case 'local':
    default:
      return localConfig
  }
}

declare global {
  interface Window {
    __ENV__: Environment
  }
}

export const env = getEnvConfig()
